module.exports = __webpack_public_path__ + "static/media/logo4.5c809f3f.jpg";